module.exports = __webpack_public_path__ + "static/media/explorer.332e5a02.png";